import React from "react";
import { Col, Row } from "react-bootstrap";

import {
  IoCarSportSharp,
  IoFitnessSharp,
  IoCameraSharp,
} from "react-icons/io5";
import { GiSoccerBall, GiGamepad } from "react-icons/gi";

function InterestStack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <IoCarSportSharp />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <GiSoccerBall />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <GiGamepad />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <IoFitnessSharp />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <IoCameraSharp />
      </Col>
    </Row>
  );
}

export default InterestStack;
